<div class="filemanager-container" style="margin:10px;">
  <div class="fm-header">
    <ri-toolbar *ngIf="!selectOnly"
      #toolbar
      [currentFolderId]="currentSelectedFolderId"
      (onAddFolderClick)="onAddFolder()"
      (onUpload)="onUpload($event)"
      (onMenuButtonClick)="onMenuButtonClick($event)"
      (onModeChange)="onModeChange($event)"
    ></ri-toolbar>
  </div>

  <div class="fm-main-box">
    <div class="folders-box">
      <ri-tree [treeModel]="treeModel"></ri-tree>
    </div>
    <div class="files-box" style="margin-left: 50px; border-left: 1px solid gray; width: calc(100% - 300px);">
      <!--ri-tree-parents-list [treeModel]="treeModel"></ri-tree-parents-list-->
      <ri-files-list [files]="filteredFiles$ | async"
                     [selectOnly]="selectOnly"
                     [selectedFiles]="selectedFiles$ | async"
                     (onPreviewFile)="onPreviewFile($event)"
                     (onSelectFile)="onSelectFile($event)"
                     (externalSelect)="external($event)"
                     [mode]="mode$ | async"
      ></ri-files-list>
    </div>
  </div>
  <!--div *ngIf="isPreviewMode" class="backdrop">
    <div class="modal-view">
      <div class="modal-close">
        <i class="fa fa-2x fa-times" (click)="closeModal()"></i>
      </div>
      <ri-file-preview *ngIf="isPreviewMode" [files]="filteredFiles$ | async"
                       [file]="currentSelectedFile"></ri-file-preview>
    </div>
  </div-->
  <simple-notifications [options]="notificationOptions"></simple-notifications>
</div>
